
import { Component, Vue, Prop } from 'vue-property-decorator';
import ShippingLabelForm from './ShippingLabelForm.vue';
import { GET_SHIPPING_CONFIGURATION } from '@/gql/shipping';

@Component({
  components: {
    ShippingLabelForm
  }
})
export default class ShippingLabels extends Vue {
  @Prop({ required: true }) orderId!: number;
  @Prop({ required: false }) pickTicketId?: number;
  @Prop({ default: false }) isShipperMode!: boolean;

  testMode = false;
  supportsMultipleNotificationEmails = false;
  loading = true;

  async mounted() {
    await this.fetchShippingConfiguration();
  }

  async fetchShippingConfiguration() {
    try {
      const { data } = await this.$apollo.query({
        query: GET_SHIPPING_CONFIGURATION,
        fetchPolicy: 'network-only'
      });

      if (data?.shippingConfiguration) {
        this.testMode = data.shippingConfiguration.testMode;
        this.supportsMultipleNotificationEmails = data.shippingConfiguration.supportsMultipleNotificationEmails === true;
      }
    } catch (error) {
      console.error('Failed to fetch shipping configuration:', error);
      // Default to false (live mode) on error
      this.testMode = false;
    } finally {
      this.loading = false;
    }
  }

  onLabelCreated(data: any) {
    this.$emit('label-created', data);
  }

  onError(error: any) {
    this.$emit('error', error);
  }

  onSuccess(message: string) {
    this.$emit('success', message);
  }

  handleFormClose() {
    // Instead of hiding the form, emit close event to parent
    this.$emit('close');
  }
}
